// FieldTypeField.jsx

import React from 'react';

// Components
import ModalField from 'components/modal/field/ModalField';
import ModalHint from 'components/modal/hint/ModalHint';
import ModalLabel from 'components/modal/label/ModalLabel';
import SelectInput from 'components/selectinput/SelectInput';

/**
 * FieldTypeField
 *
 * Renders the field type selector.
 *
 * @param {string} draftType - Currently selected field type.
 * @param {array} mergedTypeOptions - Available field type options.
 * @param {function} onTypeChange - Handler for changing the field type.
 * @param {boolean} disabled - Whether the field type selector is disabled.
 * @param {string} error - Error message for the field type selector.
 *
 * @returns {ReactNode} The rendered component.
 */
const FieldTypeField = ({
    draftType,
    mergedTypeOptions,
    onTypeChange,
    disabled,
    error,
}) => {

  // ----- RENDER ----- //

  return (

    <ModalField>

        <ModalLabel label="Field Type" />
        <ModalHint hint="The type of field you want to create." />

        <SelectInput
          style={{
            width: '100%',
          }}
          value={draftType}
          options={mergedTypeOptions}
          placeholder="Select a type"
          disabled={disabled}
          error={!!error}
          helperText={error}
          onValueChange={(value) => onTypeChange(value)}
        />

    </ModalField>

);
};

// Dev Tools
FieldTypeField.displayName = 'FieldTypeField';

export default FieldTypeField;
